import { render, staticRenderFns } from "./SidenavRouterLink.vue?vue&type=template&id=ca9ff5cc&"
import script from "./SidenavRouterLink.vue?vue&type=script&lang=js&"
export * from "./SidenavRouterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports